module.exports = __webpack_public_path__ + "assets/img/rcta3.d6910fc5.png";